import config from "../../config.json";

// Store-based onboarding (Phase 3): the client's own store, read and written through /store-onboarding/stores/:storeId/*.
// Every call returns the server's answer or throws an ApiError carrying the server's `code` (ONBOARDING_LOCKED, INCOMPLETE, ...).

const BASE = config.BASE_AUTH_API;

export class ApiError extends Error {
  constructor(message, { status = 0, code = null, missing = null } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.missing = missing;
  }
}

const request = async (token, endpoint, { method = "GET", body, file } = {}) => {
  let response;
  try {
    const headers = { Accept: "application/json", Authorization: `Bearer ${token}` };
    let payload;
    if (file) {
      payload = new FormData();
      payload.append("file", file);
    } else if (body !== undefined) {
      headers["Content-Type"] = "application/json";
      payload = JSON.stringify(body);
    }
    response = await fetch(`${BASE}store-onboarding/${endpoint}`, { method, headers, body: payload });
  } catch (error) {
    throw new ApiError(error.message || "Network error", { code: "NETWORK" });
  }
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok || !data?.success) {
    throw new ApiError(data?.message || "Request failed", { status: response.status, code: data?.code || null, missing: data?.missing || null });
  }
  return data;
};

const store = (storeId) => `stores/${encodeURIComponent(storeId)}`;

export const getDraftOverviewAPI = async (token, storeId) => (await request(token, store(storeId))).data;
export const updateDraftProfileAPI = async (token, storeId, payload) => (await request(token, `${store(storeId)}/profile`, { method: "PUT", body: payload })).data;
export const submitDraftAPI = async (token, storeId) => (await request(token, `${store(storeId)}/submit`, { method: "POST", body: {} })).data;
export const addDraftBranchAPI = async (token, storeId, payload) => (await request(token, `${store(storeId)}/branches`, { method: "POST", body: payload })).data;
export const updateDraftBranchAPI = async (token, storeId, branchId, payload) => (await request(token, `${store(storeId)}/branches/${encodeURIComponent(branchId)}`, { method: "PUT", body: payload })).data;
export const removeDraftBranchAPI = async (token, storeId, branchId) => (await request(token, `${store(storeId)}/branches/${encodeURIComponent(branchId)}`, { method: "DELETE" })).data;
export const uploadDraftDocumentAPI = async (token, storeId, key, file) => (await request(token, `${store(storeId)}/documents/${encodeURIComponent(key)}`, { method: "POST", file })).documents;
export const removeDraftDocumentAPI = async (token, storeId, key) => (await request(token, `${store(storeId)}/documents/${encodeURIComponent(key)}`, { method: "DELETE" })).documents;
export const getDraftDocumentUrlAPI = async (token, storeId, key) => (await request(token, `${store(storeId)}/documents/${encodeURIComponent(key)}/url`)).url;

// Administrators
export const getAdminStoreOnboardingAPI = async (token, storeId) => request(token, `admin/${store(storeId)}`);
export const decideAdminStoreOnboardingAPI = async (token, storeId, action, reason = "") =>
  (await request(token, `admin/${store(storeId)}/${action}`, { method: "PUT", body: { reason } })).data;
